import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { A } from 'components/common/Link/Link'
import Theme from 'components/common/Theme/Theme'
import SelectedFilter from './SelectedFilter'

const BRADCRUMBS_DEFAULT_TITLE = 'Selected Filters'

const FilterBreadcrumbs = ({
  className,
  onFilterClear,
  onFilterRemove,
  selectedFilters,
  title,
  clearAllNavigationState
}) =>
  <FilterResult className={ className }>
    <Title data-at-filter-breadcrumbs-title>{ title || BRADCRUMBS_DEFAULT_TITLE }</Title>
    <Clear
      data-at-filter-breadcrumbs-clearall
      prevent
      handler={ () => { onFilterClear(clearAllNavigationState) } }>Clear All</Clear>
    {
      selectedFilters.map(({ navigationState, label, count, ...props }) =>
        <SelectedFilter
          { ...props }
          key={ label }
          value={ `${label} ${count !== undefined ? `(${count})` : ''}` }
          navigationState={ navigationState }
          onFilterRemove={ onFilterRemove } />
      )
    }
  </FilterResult>

export default FilterBreadcrumbs

FilterBreadcrumbs.propTypes = {
  className: PropTypes.string,
  clearAllNavigationState: PropTypes.string,
  onFilterClear: PropTypes.func,
  onFilterRemove: PropTypes.func,
  selectedFilters: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string
}

const FilterResult = styled.div`
  position: relative;
  border-top: 1px solid ${Theme.colors.light_grey};
  padding: 21px 20px 29px 0;
`

const Clear = styled(A)`
  position: absolute;
  top: 21px;
  right: 0;
`

const Title = styled.div`
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
`

